<template>
	<div id="detail">
		<div class="cent">
			<topinfo></topinfo>
			<navbar @getinfo="getinfo"></navbar>
			<detailtop :iteminfo="iteminfo" :isshow="isshow" @routerpush="routerpush"></detailtop>
			<pgination @isindex="isindex" style="text-align: center;margin-top: 30px;" :count="count"></pgination>
		</div>
		<banquan></banquan>
	</div>
</template>

<script>
	import topinfo from 'components/topinfo/topinfo'
	import navbar from 'components/navbar/navbar'
	import detailtop from './child/detailtop'
	import pgination from 'components/pgination/pgination'
	import banquan from 'components/banquan/banquan'
	
	import error from 'components/alerts/error'
	
	import {getnavinfo} from 'network/home'
	
	export default{
		name:'detail',
		data(){
			return{
				iteminfo:[],
				count:0,
				isshow:true
			}
		},
		mounted(){
			this.iteminfo=[]
			document.title = this.$route.params.id+'-综合优质网络资源收集分享_游戏辅助资源下载网_爱资源_爱分享'
			getnavinfo(this.$route.params.id).then(res =>{
				this.iteminfo.push(...res.data.msg)
				this.count = this.count = this.iteminfo[0]['count']
			}).catch(()=>{
					this.count=0
					this.isshow=false
				})
		},
		methods:{
			getinfo(name,index){
				document.title = name+'-综合优质网络资源收集分享_游戏辅助资源下载网_爱资源_爱分享'
				this.iteminfo =[]
				getnavinfo(name,index).then(res =>{
					this.iteminfo.push(...res.data.msg)
					this.count = this.iteminfo[0]['count']
				}).catch(()=>{
					this.count=0
					this.isshow=false
				})
			},
			//根据index调用getinfo方法发送请求
			isindex(index){
				this.getinfo(this.$route.params.id,index)
			},
			//跳转进入详情页
			routerpush(index){
				this.$router.push('/home/'+this.$route.params.id+'/'+index)
			},
		},
		components:{
			topinfo,
			navbar,
			detailtop,
			banquan,
			pgination,
			error
		}
	}
</script>

<style scoped>
	#detail{
		background: url('https://api.ixiaowai.cn/api/api.php') no-repeat top;
		height: 100%;
		background-size:100% 100%;
	}
	.cent{
		padding-top: 5px;
		width: 1200px;
		height: 1400px;
		background: #ffffff;
		box-shadow: 0px 0px 5px 5px #c0c0c0;
		margin: auto;
	}
</style>